// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"7c4c91e3","831":"d749e279"}[chunkId] + ".chunk.js";
};